
export const handleErrorState = (state, action, backendFieldName) => {
  state.loading = false;
  state[backendFieldName] = action.payload?.[backendFieldName];
  state.serverError = action.payload?.serverError;
  state.networkError = action.payload?.networkError;
  state.unknownError = action.payload?.unknownError;
};